import { withLoading } from '../hoc'

// Import các component header
import { BrandingHeader } from '../plannet-branding/branding-header.component'
import { EducationHeader } from '../education-branding/education-header.component'
import { UnitedAnesthesiaHeader } from '../united-anesthesia-branding/united-anesthesia-header.component'
import { GHRHeader } from '../ghr-branding/ghr-header.component'

// Import các component footer
import { BrandingFooter } from '../plannet-branding/branding-footer.component'
import { EducationFooter } from '../education-branding/education-footer.component'
import { UnitedAnesthesiaFooter } from '../united-anesthesia-branding/united-anesthesia-footer.component'
import { GHRFooter } from '../ghr-branding/ghr-footer.component'

// Áp dụng HOC withLoading cho các component header
export const LoadingBrandingHeader = withLoading(BrandingHeader, { loadingTime: 2000 })
export const LoadingEducationHeader = withLoading(EducationHeader, { loadingTime: 1000 })
export const LoadingUnitedAnesthesiaHeader = withLoading(UnitedAnesthesiaHeader, { loadingTime: 1000 })
export const LoadingGHRHeader = withLoading(GHRHeader, { loadingTime: 2000 })

// Áp dụng HOC withLoading cho các component footer
export const LoadingBrandingFooter = withLoading(BrandingFooter, { loadingTime: 2000, backgroundColor: '#f5f5f5' })
export const LoadingEducationFooter = withLoading(EducationFooter, { loadingTime: 1000, backgroundColor: '#f5f5f5' })
export const LoadingUnitedAnesthesiaFooter = withLoading(UnitedAnesthesiaFooter, { loadingTime: 1000, backgroundColor: '#f5f5f5' })
export const LoadingGHRFooter = withLoading(GHRFooter, { loadingTime: 2000, backgroundColor: '#f5f5f5' })
